
import React, { useState } from 'react';
import { SaveProjectDialog } from '../SaveProjectDialog';
import { ExportDialog } from '../ExportDialog';
import { ImportExcelDialog } from '../import/ImportExcelDialog';
import { Category, Account } from '@/types';
import { exportToExcel } from '@/utils/excelExport';
import { exportToCSV } from '@/utils/csvExport';
import { downloadState } from '@/utils/stateManagement';

interface DialogManagerProps {
  categories: Category[];
  accounts: Account[];
  expanded: Set<string>;
  isSaveDialogOpen: boolean;
  isExportDialogOpen: boolean;
  isExportCSVDialogOpen: boolean;
  isImportExcelDialogOpen: boolean;
  onSaveDialogChange: (isOpen: boolean) => void;
  onExportDialogChange: (isOpen: boolean) => void;
  onExportCSVDialogChange: (isOpen: boolean) => void;
  onImportExcelDialogChange: (isOpen: boolean) => void;
  onCategoriesImported: (categories: Category[]) => void;
}

export function DialogManager({
  categories,
  accounts,
  expanded,
  isSaveDialogOpen,
  isExportDialogOpen,
  isExportCSVDialogOpen,
  isImportExcelDialogOpen,
  onSaveDialogChange,
  onExportDialogChange,
  onExportCSVDialogChange,
  onImportExcelDialogChange,
  onCategoriesImported
}: DialogManagerProps) {
  const [projectName, setProjectName] = useState('');
  const [exportName, setExportName] = useState('');

  const handleSaveWithProjectName = () => {
    const state = {
      categories,
      expanded: Array.from(expanded),
      accounts
    };
    
    downloadState(state, projectName.trim());
    onSaveDialogChange(false);
    setProjectName('');
  };

  const handleExport = async () => {
    try {
      console.log('Starting export with categories:', categories);
      await exportToExcel(categories, exportName.trim());
      onExportDialogChange(false);
      setExportName('');
    } catch (error) {
      console.error('Export failed:', error);
    }
  };

  const handleExportCSV = async () => {
    try {
      console.log('Starting CSV export with categories:', categories);
      await exportToCSV(categories, exportName.trim());
      onExportCSVDialogChange(false);
      setExportName('');
    } catch (error) {
      console.error('CSV Export failed:', error);
    }
  };

  return (
    <>
      <SaveProjectDialog
        open={isSaveDialogOpen}
        onOpenChange={onSaveDialogChange}
        projectName={projectName}
        setProjectName={setProjectName}
        onSave={handleSaveWithProjectName}
      />

      <ExportDialog
        open={isExportDialogOpen}
        onOpenChange={onExportDialogChange}
        exportName={exportName}
        setExportName={setExportName}
        onExport={handleExport}
      />

      <ExportDialog
        open={isExportCSVDialogOpen}
        onOpenChange={onExportCSVDialogChange}
        exportName={exportName}
        setExportName={setExportName}
        onExport={handleExportCSV}
      />

      <ImportExcelDialog
        isOpen={isImportExcelDialogOpen}
        onOpenChange={onImportExcelDialogChange}
        onCategoriesImported={onCategoriesImported}
      />
    </>
  );
}
